/** Normalize serve-injected CDN prefix for webpack chunk URLs */
const resolveWebpackPublicPath = (windowValue) => {
  const trimmed = typeof windowValue === 'string' ? windowValue.trim() : '';

  if (!trimmed) {
    return '/';
  }

  return trimmed.endsWith('/') ? trimmed : `${trimmed}/`;
};

module.exports = { resolveWebpackPublicPath };
